import "bootstrap/dist/css/bootstrap.min.css"
import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"
import utc from "dayjs/plugin/utc"
import React, { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { ToastProvider } from "react-toast-notifications"
import { PersistGate } from "redux-persist/integration/react"
import App from "./App"
import { ValidateProvider } from "./providers/ValidateProvider"
import { persistor, store } from "./store"
import "./styles/index.css"
import "./styles/tdHover.css"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
dayjs.extend(duration)
dayjs.extend(utc)
const container = document.getElementById("root")
const root = createRoot(container)
root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ToastProvider>
				<StrictMode>
					<ValidateProvider>
						<DndProvider backend={HTML5Backend}>
							<App />
						</DndProvider>
					</ValidateProvider>
				</StrictMode>
			</ToastProvider>
		</PersistGate>
	</Provider>
)




